import { useEffect } from "react";

/**
 * Sets document.title + meta description + canonical for the current page.
 * SPA-safe: reverts nothing on unmount (next page will overwrite).
 */
export const usePageMeta = ({ title, description, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }

    if (canonical) {
      let c = document.querySelector('link[rel="canonical"]');
      if (!c) {
        c = document.createElement("link");
        c.setAttribute("rel", "canonical");
        document.head.appendChild(c);
      }
      c.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);
};

export default usePageMeta;
